import React from "react";
import { Debt } from "../../lib/types";
import { debtShareAPI } from "../../services/api/api";
import ShareModal, { ExistingShare } from "../common/ShareModal";

interface ShareDebtModalProps {
  open: boolean;
  debt: Debt | null;
  onClose: () => void;
}

const ShareDebtModal: React.FC<ShareDebtModalProps> = ({
  open,
  debt,
  onClose,
}) => {
  const isGroupShare = debt?.id?.startsWith("group:");
  const creditor = isGroupShare ? debt?.id?.replace("group:", "") : null;

  const getTitle = () => {
    if (isGroupShare) {
      return `Share Debts: ${creditor}`;
    }
    return `Share Debt: ${debt?.creditor || debt?.account || "Unknown"}`;
  };

  const getItemDescription = () => {
    return isGroupShare ? "this group of debts" : "this debt";
  };

  const handleCreateShare = async (
    password: string,
    expiresAt: string | null
  ): Promise<{ shareId: string }> => {
    const params = isGroupShare
      ? { creditor: creditor!, password, expiresAt }
      : { debtId: debt!.id, password, expiresAt };

    return await debtShareAPI.create(params);
  };

  const handleListShares = async (): Promise<ExistingShare[]> => {
    if (!debt) return [];
    const params = isGroupShare ? { creditor: creditor! } : { debtId: debt.id };
    const shares = await debtShareAPI.listForDebt(params);
    // Map API response to ExistingShare interface
    return shares.map((s) => ({
      id: s.share_id,
      createdAt: s.created_at,
      expiresAt: s.expires_at,
    }));
  };

  const handleDeleteShare = async (shareId: string): Promise<void> => {
    await debtShareAPI.delete(shareId);
  };

  const buildShareUrl = (shareId: string): string => {
    const baseUrl = window.location.origin;
    return `${baseUrl}/shared/debts/${shareId}`;
  };

  if (!debt) {
    return null;
  }

  return (
    <ShareModal
      open={open}
      onClose={onClose}
      title={getTitle()}
      itemDescription={getItemDescription()}
      createShare={handleCreateShare}
      listShares={handleListShares}
      deleteShare={handleDeleteShare}
      buildShareUrl={buildShareUrl}
    />
  );
};

export default ShareDebtModal;
